import { render, staticRenderFns } from "./ClienteEdit.vue?vue&type=template&id=8f8d1ef4"
import script from "./ClienteEdit.vue?vue&type=script&lang=js"
export * from "./ClienteEdit.vue?vue&type=script&lang=js"
import style0 from "./ClienteEdit.vue?vue&type=style&index=0&id=8f8d1ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports